<script setup lang="ts">
    import { defaultRepeaterConverter } from "@/components/forms/groups/Repeater/helpers";
    import { getConfig, klinikenApi } from "@/api";
    import { Option } from "@/components/forms/inputs/Autocomplete/types";
    import { openDialog } from "@/utils";
    import { convertImplantatData, Implantat } from "@/components/forms/reusables/implantatHelper";

    const fetchImplantat = async () => {
        try {
            const response = await klinikenApi.get("/operation/implantat/", getConfig());
            return response.data.results.map((item: Implantat) => convertImplantatData({ implantat: item }));
        } catch (error) {
            console.error(error);
            openDialog("Kunde inte hämta implantat.", "warning");
        }
    };
</script>

<template>
    <KRepeater
        name="implantat"
        add-label="Lägg till implantat"
        remove-label="Ta bort implantat"
        :converter="defaultRepeaterConverter"
        #default="{ index, model }"
    >
        <KAutocomplete
            name="id"
            :options="fetchImplantat"
            label="Implantat"
            :value="model?.[index]?.id ?? null"
            class="span-all"
        />
    </KRepeater>
</template>

<style scoped lang="scss"></style>
